module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isVisible) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.option.display_type !== 'hidden'),
      expression: "option.display_type !== 'hidden'"
    }],
    staticClass: "builder__step",
    class: {
      'builder__step--expanded': _vm.isExpanded
    }
  }, [(_vm.option.is_embroidery_grouped != '1') ? _c('div', {
    staticClass: "builder__step-heading-and-tip"
  }, [_c('div', {
    staticClass: "builder__step-heading"
  }, [_c('h3', {
    staticClass: "builder__step-heading-main"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleOptionVisibility
    }
  }, [_vm._v(_vm._s(_vm.option.display_title ? _vm.option.display_title : _vm.option.title))])])]), _vm._v(" "), (_vm.has_tip) ? _c('div', {
    staticClass: "builder__step-tip"
  }, [_c('div', {
    staticClass: "builder__step-tip-trigger"
  }, [_c('button', {
    on: {
      "click": _vm.showTipPopup
    }
  }, [_vm._v("Tip")])]), _vm._v(" "), _c('div', {
    staticClass: "mfp-hide builder__step-tip-content",
    attrs: {
      "id": _vm.tipPopupDomId
    },
    domProps: {
      "innerHTML": _vm._s(_vm.option.tip_text)
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "builder__step-content"
  }, [(_vm.option.display_type == 'embroidery') ? _c('builder-option-embroidery', {
    attrs: {
      "option": _vm.option
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input', _vm.option.id, $event)
      },
      "toggle-embroidery": function($event) {
        _vm.isEmbroideryGroupVisible = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "builder__step-options",
    class: {
      'builder__step-options--expanded': _vm.isEmbroideryGroupVisible
    }
  }, [(_vm.option.display_type != 'embroidery') ? _c('div', {
    staticClass: "builder__step-option"
  }, [_c(_vm.componentNameForOptionType(_vm.option.display_type), {
    tag: "component",
    attrs: {
      "option": _vm.option
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input', _vm.option.id, $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.option.embroidery_grouped_options), function(subOption) {
    return _c('div', {
      staticClass: "builder__step-option"
    }, [_c('builder-option', {
      attrs: {
        "option": subOption
      },
      on: {
        "input": _vm.propagateInput
      }
    })], 1)
  })], 2)], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0acd9481"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Option.vue
// module id = 365
// module chunks = 0